var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "g",
    {
      attrs: {
        id: "Page-1",
        stroke: "none",
        "stroke-width": "1",
        fill: "none",
        "fill-rule": "evenodd"
      }
    },
    [
      _c(
        "g",
        {
          attrs: {
            id: "Desktop-HD",
            transform: "translate(-123.000000, -269.000000)"
          }
        },
        [
          _c(
            "g",
            {
              attrs: {
                id: "icons/battery-cel-level-0",
                transform: "translate(123.000000, 269.000000)"
              }
            },
            [
              _c("rect", {
                staticStyle: { "mix-blend-mode": "color-burn" },
                attrs: {
                  id: "Rectangle",
                  "fill-opacity": "0.01",
                  fill: "#E3E3E3",
                  x: "0",
                  y: "0",
                  width: "24",
                  height: "24"
                }
              }),
              _vm._v(" "),
              _c(
                "g",
                {
                  attrs: {
                    id: "Group-4",
                    "stroke-width": "1",
                    transform: "translate(6.000000, 2.000000)"
                  }
                },
                [
                  _c("rect", {
                    attrs: {
                      id: "Rectangle",
                      fill: "#FF6B0E",
                      x: "0",
                      y: "3",
                      width: "12",
                      height: "17"
                    }
                  }),
                  _vm._v(" "),
                  _c("rect", {
                    attrs: {
                      id: "Rectangle",
                      fill: "#FFFFFF",
                      x: "2",
                      y: "5",
                      width: "8",
                      height: "13"
                    }
                  }),
                  _vm._v(" "),
                  _c("rect", {
                    attrs: {
                      id: "Rectangle",
                      fill: "#FF6B0E",
                      x: "4",
                      y: "0",
                      width: "4",
                      height: "2"
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M12.4623273,10.2031 C12.3914182,10.1791 12.3183273,10.1591 12.2463273,10.1431 C12.1656,10.1391 12.0837818,10.1391 12.0052364,10.1431 L11.9332364,10.1431 L11.7892364,10.1431 C11.7063273,10.1491 11.6234182,10.1661 11.5481455,10.1931 C11.4761455,10.2141 11.4074182,10.2401 11.3441455,10.2721 C11.2743273,10.3001 11.2110545,10.3331 11.1510545,10.3721 L10.9939636,10.5301 L10.8870545,10.6201 L10.8870545,10.6801 L10.8139636,10.8581 L10.8139636,11.0571 L10.8139636,14.3301 L7.80741818,12.8911 C7.23032727,12.6181 6.49287273,12.7821 6.16014545,13.2591 C5.82850909,13.7351 6.02814545,14.3451 6.60523636,14.6181 L11.4161455,16.9101 L11.4870545,16.9101 C11.5579636,16.9341 11.6299636,16.9541 11.7052364,16.9701 C11.7837818,16.9741 11.8645091,16.9741 11.9441455,16.9701 L11.9332364,17.0391 L12.0772364,17.0391 C12.1612364,17.0331 12.2408727,17.0161 12.3172364,16.9891 C12.3892364,16.9691 12.4568727,16.9421 12.5234182,16.9101 C12.5899636,16.8831 12.6554182,16.8491 12.7143273,16.8101 L12.8703273,16.6521 C12.9096,16.6251 12.9456,16.5951 12.9794182,16.5621 L12.9794182,16.4931 L12.9794182,16.4041 C13.0590545,16.2951 13.1125091,16.1731 13.1354182,16.0471 L13.1354182,12.8031 L16.1419636,14.2411 C16.7201455,14.5151 17.4586909,14.3501 17.7903273,13.8741 C18.1208727,13.3971 17.9223273,12.7891 17.3452364,12.5151 L12.5343273,10.2231 C12.5343273,10.2231 12.4852364,10.2131 12.4623273,10.2031",
                  id: "Fill-4",
                  stroke: "#FFFFFF",
                  "stroke-width": "3",
                  fill: "#FF6B0E"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M12.2463273,10.1431 C12.1656,10.1391 12.0837818,10.1391 12.0052364,10.1431 L11.9332364,10.1431 L11.7892364,10.1431 C11.7063273,10.1491 11.6234182,10.1661 11.5481455,10.1931 C11.4761455,10.2141 11.4074182,10.2401 11.3441455,10.2721 C11.2743273,10.3001 11.2110545,10.3331 11.1510545,10.3721 L10.9939636,10.5301 L10.8870545,10.6201 L10.8870545,10.6801 L10.8139636,10.8581 L10.8139636,11.0571 L10.8139636,14.3301 L7.80741818,12.8911 C7.23032727,12.6181 6.49287273,12.7821 6.16014545,13.2591 C5.82850909,13.7351 6.02814545,14.3451 6.60523636,14.6181 L11.4161455,16.9101 L11.4870545,16.9101 C11.5579636,16.9341 11.6299636,16.9541 11.7052364,16.9701 C11.7837818,16.9741 11.8645091,16.9741 11.9441455,16.9701 L11.9332364,17.0391 L12.0772364,17.0391 C12.1612364,17.0331 12.2408727,17.0161 12.3172364,16.9891 C12.3892364,16.9691 12.4568727,16.9421 12.5234182,16.9101 C12.5899636,16.8831 12.6554182,16.8491 12.7143273,16.8101 L12.8703273,16.6521 C12.9096,16.6251 12.9456,16.5951 12.9794182,16.5621 L12.9794182,16.4931 L12.9794182,16.4041 C13.0590545,16.2951 13.1125091,16.1731 13.1354182,16.0471 L13.1354182,12.8031 L16.1419636,14.2411 C16.7201455,14.5151 17.4586909,14.3501 17.7903273,13.8741 C18.1208727,13.3971 17.9223273,12.7891 17.3452364,12.5151 L12.5343273,10.2231 C12.5343273,10.2231 12.4852364,10.2131 12.4623273,10.2031 C12.3914182,10.1791 12.3183273,10.1591 12.2463273,10.1431 Z",
                  id: "Fill-4",
                  fill: "#FF6B0E"
                }
              })
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }